"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.personalData.name': 'Rilevamento Dati Personali',
    'tools.personalData.description': 'Estrai e categorizza dati personali dai messaggi degli utenti come numeri di telefono, email, indirizzi, nomi, ecc.',
};
